const DAY = 864e5;
export const schoolDay = (value: any, zone?: string) => new Date(value).toLocaleDateString('en-CA', {timeZone: zone || 'UTC'});

export function reportingYear(periods: any, data: any) {
  if (!data?.period?.from) return undefined;
  const from = schoolDay(data.period.from, data.timezone);
  return periods?.calendar?.years?.find(year => year.start <= from && year.end >= from);
}

// Count actual calendar weeks containing selected teaching weekdays, excluding holidays.
// Without teaching blocks a calendar date is more honest than an assumed 39-week year.
export function teachingWeek(year: any, at: string, selectedIds: string[] = []) {
  const terms = (year?.terms || []).filter(term => selectedIds.includes(term.id));
  if (!terms.some(term => term.start <= at && term.end >= at)) return null;
  const monday = (date: Date) => +date - ((date.getUTCDay() + 6) % 7) * DAY;
  const weeks = new Set<number>();
  for (let date = new Date(year.start); +date <= +new Date(year.end); date = new Date(+date + DAY)) {
    const day = date.toISOString().slice(0,10);
    if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && terms.some(term => term.start <= day && term.end >= day)) weeks.add(monday(date));
  }
  const current = [...weeks].filter(week => week <= monday(new Date(at))).length;
  return current ? {current, total: weeks.size} : null;
}

export function overviewPeriodContext(periods: any, data: any) {
  if (!data) return 'School participation';
  const year = reportingYear(periods, data);
  const from = schoolDay(data.period.from, data.timezone);
  const at = schoolDay(Math.min(+new Date(data.sourceCutoffAt), +new Date(data.period.to) - 1), data.timezone);
  if (year && from <= year.start && at >= year.end) return `${year.name} · Full academic year`;
  const term = year?.terms?.find(term => term.start <= at && term.end >= at);
  const week = teachingWeek(year, at, data.overviewSettings?.teachingTermIds);
  const label = term?.name || year?.name || 'Selected period';
  const date = value => new Date(value + 'T12:00:00Z').toLocaleDateString('en-GB', {day:'numeric', month:'short', timeZone:'UTC'});
  return week ? `${label} · teaching week ${week.current} of ${week.total}` : `${label} · ${date(from)} – ${date(at)}`;
}

export function academicMonthTicks(start: number, end: number) {
  const ticks: Array<{at: number; label: string}> = [];
  const date = new Date(start);
  date.setUTCDate(1);
  while (+date < end && ticks.length < 24) {
    ticks.push({at: Math.max(start,+date), label: date.toLocaleDateString('en-GB',{month:'short',timeZone:'UTC'})});
    date.setUTCMonth(date.getUTCMonth()+1);
  }
  return ticks;
}
